import { useState, useCallback } from 'react';

// XP nécessaire par niveau = niveau * 500
const XP_PER_LEVEL = 500;

// Fonctionnalités débloquées à certains niveaux
const UNLOCKS = {
  5:  'Mode Duel débloqué !',
  10: 'Mode Multijoueur débloqué !',
  15: 'Tournois débloqués !',
  20: 'Questions Légendaires débloquées !',
  30: 'Titre "Expert" débloqué !',
  50: 'Titre "Légende" débloqué !',
};

// Pièces gagnées au level-up = niveau * 100
const coinsForLevel = (level) => level * 100;

/**
 * Hook useLevelUp
 * Retourne: { checkLevelUp, levelUpData, clearLevelUp }
 *
 * checkLevelUp(currentUser, xpGained) → retourne le nouvel user si level-up, sinon null
 */
function useLevelUp() {
  const [levelUpData, setLevelUpData] = useState(null); // { newLevel, coinsEarned, unlockedFeature }

  const checkLevelUp = useCallback((user, xpGained) => {
    if (!user) return null;

    const currentLevel = user.level || user.niveau || 1;
    const currentXp = (user.xp || 0) + xpGained;
    const xpNeededForNext = currentLevel * XP_PER_LEVEL;

    if (currentXp >= xpNeededForNext) {
      const newLevel = currentLevel + 1;
      const coins = coinsForLevel(newLevel);
      const unlockedFeature = UNLOCKS[newLevel] || null;

      setLevelUpData({ newLevel, coinsEarned: coins, unlockedFeature });

      return {
        ...user,
        level: newLevel,
        niveau: newLevel,
        xp: currentXp - xpNeededForNext, // XP restant après level-up
        coins: (user.coins || 0) + coins,
      };
    }

    // Pas de level-up, juste mettre à jour l'XP
    return { ...user, xp: currentXp };
  }, []);

  const clearLevelUp = useCallback(() => setLevelUpData(null), []);

  return { checkLevelUp, levelUpData, clearLevelUp };
}

export default useLevelUp;
